import { COMMENT_SUMMARY_TYPE, REMOTE_ISSUE_LINKS_TYPE } from '@atlassian/jira-business-constants';
import { COMMENT_TYPE } from '@atlassian/jira-platform-field-config';

export const VALIDATION_ERROR_CODES = {
	NULL_GETTER: 'NULL_GETTER',
	MISSING_FIELD: 'MISSING_FIELD',
	MISSING_ISSUE: 'MISSING_ISSUE',
	NON_COMPATIBLE_FIELD_TYPE: 'NON_COMPATIBLE_FIELD_TYPE',
	EMPTY_CLIPBOARD: 'EMPTY_CLIPBOARD',
	NON_EDITABLE: 'NON_EDITABLE',
};

export const SUPPORTED_TOP_LEVEL_FIELD_TYPES = [
	COMMENT_TYPE,
	COMMENT_SUMMARY_TYPE,
	REMOTE_ISSUE_LINKS_TYPE,
];
